import { VERSION } from '../constants'
import { initSentry } from '../utils/sentry'
import { initIoPrintButtonConfig } from './io-print-button-config'

/* eslint-disable no-console */
export default function (): void {
  console.log(`Infinite Objects Print Button v${VERSION}`)
  initSentry()
  initIoPrintButtonConfig()
}
